'use strict';/* global define */define('modules/users/services/slack/index',['require','exports','module'],function(require,exports,module){'use strict';// @ngInject
factory.$inject = ["$resource", "API_ENDPOINT"];
function factory($resource,API_ENDPOINT){// jshint validthis:true
// jshint latedef:false
return $resource(API_ENDPOINT+'integrations/:integrationId/user/:userId',{userId:'@userId',integrationId:'@integrationId'},{update:{method:'PATCH'}});}module.exports=factory;});
